import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-900020e2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "hd-bespoke-sars-cov-2-variants" }
const _hoisted_2 = { class: "hd-bespoke-sars-cov-2-variants__tabs" }
const _hoisted_3 = { class: "hd-bespoke-sars-cov-2-variants__container" }
const _hoisted_4 = { class: "hd-bespoke-sars-cov-2-variants__side hd-bespoke-sars-cov-2-variants__side--left" }
const _hoisted_5 = { class: "hd-bespoke-sars-cov-2-variants__side hd-bespoke-sars-cov-2-variants__side--right" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = {
  class: "dark-primary-bg",
  colspan: "2"
}
const _hoisted_9 = { key: 0 }
const _hoisted_10 = {
  class: "dark-primary-bg",
  colspan: "2"
}
const _hoisted_11 = {
  class: "dark-primary-bg",
  rowspan: "2"
}
const _hoisted_12 = { class: "dark-primary-bg" }
const _hoisted_13 = { class: "dark-primary-bg" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_lyra_asset = _resolveComponent("lyra-asset")!
  const _component_base_tabs = _resolveComponent("base-tabs")!
  const _component_base_image_svg = _resolveComponent("base-image-svg")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_lyra_asset, {
      class: "hd-title",
      "asset-key": `${_ctx.endpointId}.title`
    }, null, 8, ["asset-key"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_base_tabs, {
        items: _ctx.tabs,
        "item-active-set": _ctx.tabActive,
        onTabUpdated: _ctx.activeTab,
        modifier: "ribbon"
      }, null, 8, ["items", "item-active-set", "onTabUpdated"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_lyra_asset, {
          class: "hd-c-hub__fact-overlay-button",
          "asset-key": `${_ctx.endpointId}.tab-left.${_ctx.tabActive}`
        }, null, 8, ["asset-key"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        (_ctx.tabActive === 'variant5')
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createVNode(_component_lyra_asset, {
                class: "hd-bespoke-sars-cov-2-variants-omicron",
                assetKey: "hd-bespoke-sars-cov-2-variants-omicron"
              })
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("table", null, [
                _createElementVNode("tbody", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", _hoisted_8, [
                      _createVNode(_component_lyra_asset, {
                        "asset-key": `${_ctx.endpointId}.table-variant`
                      }, null, 8, ["asset-key"])
                    ]),
                    _createElementVNode("td", null, [
                      _createVNode(_component_lyra_asset, {
                        "asset-key": `${_ctx.endpointId}.table-variant.${_ctx.tabActive}`
                      }, null, 8, ["asset-key"])
                    ])
                  ]),
                  (_ctx.tabActive !== _ctx.noImage)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_9, [
                        _createElementVNode("td", _hoisted_10, [
                          _createVNode(_component_lyra_asset, {
                            "asset-key": `${_ctx.endpointId}.table-protein`
                          }, null, 8, ["asset-key"])
                        ]),
                        _createElementVNode("td", null, [
                          _createVNode(_component_base_image_svg, {
                            source: require(`@/applications/covid-hub/ui/assets/bespoke/spike-protein-${_ctx.tabActive}.png`),
                            "is-image": true
                          }, null, 8, ["source"])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", _hoisted_11, [
                      _createVNode(_component_lyra_asset, {
                        "asset-key": `${_ctx.endpointId}.table-spike-changes`
                      }, null, 8, ["asset-key"])
                    ]),
                    _createElementVNode("td", _hoisted_12, [
                      _createVNode(_component_lyra_asset, {
                        "asset-key": `${_ctx.endpointId}.table-amino-acid`
                      }, null, 8, ["asset-key"])
                    ]),
                    _createElementVNode("td", null, [
                      _createVNode(_component_lyra_asset, {
                        "asset-key": `${_ctx.endpointId}.table-amino-acid.${_ctx.tabActive}`
                      }, null, 8, ["asset-key"])
                    ])
                  ]),
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", _hoisted_13, [
                      _createVNode(_component_lyra_asset, {
                        "asset-key": `${_ctx.endpointId}.table-amino-terminal`
                      }, null, 8, ["asset-key"])
                    ]),
                    _createElementVNode("td", null, [
                      _createVNode(_component_lyra_asset, {
                        "asset-key": `${_ctx.endpointId}.table-amino-terminal.${_ctx.tabActive}`
                      }, null, 8, ["asset-key"])
                    ])
                  ])
                ])
              ])
            ]))
      ])
    ])
  ]))
}